import { Component, ContentChild, ViewEncapsulation } from '@angular/core';
import { TmModalComponent } from '../tm-modal/tm-modal.component';

@Component({
  selector: 'tm-modal-header',
  templateUrl: './tm-modal-header.component.html',
  styleUrls: ['./tm-modal-header.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class TmModalHeaderComponent {
  @ContentChild('tmModalHeader', {static: true}) headerTemp: any;

  constructor(public modal: TmModalComponent) { }
}
